module.exports = __webpack_public_path__ + "static/media/jobs.18442452.svg";